import { Controller } from "@hotwired/stimulus"

// The Phone page's "add a day off" form (Phone_Settings_Plan.md, committee
// D-NIT 15): picking From fills To with the same day, unless To already
// holds a later day, so a one-day closure is one pick.
export default class extends Controller {
  static targets = ["from", "to"]

  fromPicked() {
    const from = this.fromTarget.value
    if (!from) return
    if (!this.toTarget.value || this.toTarget.value < from) this.toTarget.value = from
  }
}
